/* ============================================================================
   Inner Child · Doodle Line Cursor  (DESKTOP ONLY)
   Upload this file to Shopify:  Edit code → Assets → Add a new asset
   Then add ONE line before </body> in layout/theme.liquid:
     <script src="{{ 'doodle-cursor.js' | asset_url }}" defer></script>
   A crayon line trails the mouse and gently fades away. Click = next colour.
   Touch devices (phones / tablets): the effect does NOT run — normal scrolling
   and tapping, no cursor.
   Self-contained: no libraries, injects its own styles.
   ============================================================================ */
(function () {
  if (window.__doodleCursor) return;
  window.__doodleCursor = true;

  // ---- options you can tweak --------------------------------------------------
  var PALETTE     = ['#035dba', '#e84d8a', '#f5c518', '#1fa463', '#ff6b35', '#7d3cb5'];
  var LINE_WIDTH  = 5.4;     // crayon thickness in px
  var FADE_MS     = 1300;    // how long a stroke takes to fade fully away
  var GAP_MS      = 450;     // pause longer than this = a fresh stroke (no long join line)
  var JUMP_PX     = 90;      // a jump bigger than this also starts a fresh stroke

  try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
  if (!document.createElement('canvas').getContext) return;
  // don't run inside the Shopify theme editor / customizer (distracting while editing)
  if (window.Shopify && window.Shopify.designMode) return;
  // desktop only: skip touch devices (phones / tablets) entirely
  try {
    var coarse = matchMedia('(pointer: coarse)').matches;
    var noHover = matchMedia('(hover: none)').matches;
    if (coarse || noHover || ('ontouchstart' in window && !matchMedia('(pointer: fine)').matches)) return;
  } catch (e) {}

  var st = document.createElement('style');
  st.textContent =
    '#dood-canvas { position:fixed; inset:0; width:100vw; height:100vh; pointer-events:none; z-index:2147483000; }' +
    '@media (prefers-reduced-motion: reduce) { #dood-canvas { display:none !important; } }';
  document.head.appendChild(st);

  var canvas, ctx, w = 0, h = 0, dpr = 1;
  var last = null, prevMid = null, lastMoveT = 0, colorIdx = 0, color = PALETTE[0];
  var lastFrame = 0, raf = 0;

  function start() {
    canvas = document.createElement('canvas'); canvas.id = 'dood-canvas';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    document.addEventListener('pointerleave', endStroke);
    window.addEventListener('blur', endStroke);
    lastFrame = performance.now();
    raf = requestAnimationFrame(loop);
  }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var nw = window.innerWidth, nh = window.innerHeight;
    if (nw === w && nh === h) return;   // size unchanged — don't wipe the canvas
    w = nw; h = nh;
    canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function nextColor() { colorIdx = (colorIdx + 1) % PALETTE.length; color = PALETTE[colorIdx]; }
  function endStroke() { last = null; prevMid = null; }

  // draw one fresh bit of line, ONCE, at full opacity — the per-frame fade (in loop)
  // is what makes it disappear, so the line is always solid (never beaded into dots)
  function seg(x, y) {
    var now = performance.now();
    if (last && (now - lastMoveT > GAP_MS || Math.hypot(x - last.x, y - last.y) > JUMP_PX)) endStroke();
    lastMoveT = now;
    if (!last) { last = { x: x, y: y }; prevMid = { x: x, y: y }; return; }
    var mid = { x: (last.x + x) / 2, y: (last.y + y) / 2 };
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    ctx.strokeStyle = color;
    ctx.lineWidth = LINE_WIDTH; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(prevMid.x, prevMid.y);
    ctx.quadraticCurveTo(last.x, last.y, mid.x, mid.y);
    ctx.stroke();
    prevMid = mid; last = { x: x, y: y };
  }

  function onMove(e) { if (e.pointerType === 'touch') return; seg(e.clientX, e.clientY); }
  function onDown(e) { if (e.pointerType !== 'touch') nextColor(); }

  // each frame, gently fade everything already drawn toward fully transparent.
  // destination-out lowers the alpha of existing pixels (reaches zero — no ghost,
  // no seams, no dots), independent of frame rate.
  function loop(now) {
    var dt = Math.min(64, now - lastFrame); lastFrame = now;
    var k = Math.min(0.5, (dt / FADE_MS) * 4);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.globalAlpha = 1;
    ctx.fillStyle = 'rgba(0,0,0,' + k + ')';
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
    raf = requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();